export const kpiData = [
  {name: 'ConvertibleRatioScore', translationKey: 'component.iso.kpis.convertibleratio', walkme: 'isodashboard-image-convertibleratio'},
  {name: 'ClientRetentionScore', translationKey: 'component.iso.kpis.clientretention', walkme: 'isodashboard-image-clientretention'},
  {name: 'LeadCleanupQualityScore', translationKey: 'component.iso.kpis.leadcleanupquality', walkme: 'isodashboard-image-leadcleanupquality'},
  {name: 'ClaimRatioScore', translationKey: 'component.iso.kpis.claimratio', walkme: 'isodashboard-image-claimratio'}
];
